// src/HomePage.js
import React from 'react';

const HomePage = ({ onSelectMode }) => {
  return (
    <div className="home-page">
      <h1>智能交通動態查詢系統</h1>
      <div className="selection-buttons">
        <button onClick={() => onSelectMode('train')}>🚄 查詢列車動態</button>
        <button onClick={() => onSelectMode('station')}>🚉 查詢車站資訊</button>
        <button onClick={() => onSelectMode('bike')}>🚲 查詢公共自行車</button>
      </div>
    </div>
  );
};

export default HomePage;
